import client from "./client"
import {Response} from "../Model"

interface CompanyOption {
    code?: string
    name: string
    businessNature?: string
}

const getCompanySearch = (search: string) => {
    return client.get<Response<CompanyOption[]>>(
        `company/search`,
        {
            params: {
                q: search,
            },
        },
    )
}

export const NEW_COMPANY_CODE = `new_company_code`

export default getCompanySearch
export type {CompanyOption}
